import getCharts from '../getCharts'
import { PatientInternalNotesCRUD } from '../../constants/api.config'

export default async function InternalNotesCRUD(mode = "GET", patientID = "-1", internalNotes = "", pdate = "", id = "") {
  try {
    const payload = { mode, patientID, internalNotes, pdate, id }
    const res = await getCharts(PatientInternalNotesCRUD, payload)
    return res.data
  } catch (error) {
    return error
  }
}
